import React, { forwardRef } from "react";
import { currentDate, formatDayMonth } from "utils/formatDate";
import { formatNumber } from "utils/currencyFormat";

const InDsQuyTienMat = forwardRef(({ data, dauKy, cuoiKy, dateFrom, dateTo, config }, ref) => {

    const displayDateFrom = dateFrom ? formatDayMonth(dateFrom) : "01/01/1990";
    const displayDateTo = dateTo ? formatDayMonth(dateTo) : formatDayMonth(new Date());

    return (
        <div ref={ref} id="tblPrintQuyTienMatDongTien" style={{ padding: "30px", width: "100%", fontFamily: "Times New Roman, Arial, sans-serif" }}>
            <div style={{ textAlign: "center", marginBottom: "20px" }}>
                <h2 style={{ margin: 0, textTransform: "uppercase", fontSize: "24px", fontWeight: "bold" }}>
                    BÁO CÁO QUỸ TIỀN MẶT
                </h2>
                <p style={{ margin: "5px 0 0 0", fontSize: "14px", fontStyle: "italic" }}>
                    Ngày in: {currentDate()}
                </p>
            </div>
            <table
                border="1"
                className="table-bordered"
                style={{
                    borderCollapse: "collapse",
                    width: "100%",
                    fontSize: "14px",
                    color: "#000",
                    border: "1px solid #000"
                }}
            >
                <thead>
                    <tr style={{ backgroundColor: "#f2f2f2", fontWeight: "bold", height: "40px" }}>
                        <th style={{ width: "20%", textAlign: "center", border: "1px solid #000" }}>Thời gian</th>
                        <th style={{ width: "30%", textAlign: "left", paddingLeft: "10px", border: "1px solid #000" }}>Giao dịch</th>
                        <th style={{ width: "25%", textAlign: "center", border: "1px solid #000" }}>Thu</th>
                        <th style={{ width: "25%", textAlign: "center", border: "1px solid #000" }}>Chi</th>
                    </tr>
                </thead>
                <tbody>
                    <tr style={{ height: "35px" }}>
                        <td style={{ textAlign: "center", fontWeight: "bold", border: "1px solid #000" }}>
                            {displayDateFrom}
                        </td>
                        <td style={{ textAlign: "left", paddingLeft: "10px", fontWeight: "bold", border: "1px solid #000" }}>
                            Tiền đầu kỳ
                        </td>
                        <td colSpan="2" style={{ textAlign: "center", fontWeight: "bold", color: "red", border: "1px solid #000" }}>
                            {formatNumber(dauKy)}
                        </td>
                    </tr>
                    {data && data.map((item, index) => {
                        const isBanHang = config?.isBanHangTraGop === "1" || config?.IsBanHangTraGop === "1";
                        if (item.NoiDung === "Bán hàng trả góp" && !isBanHang) return null;
                        const isRutQuy = item.NoiDung === "Rút quỹ";
                        return (
                            <tr key={index} style={{ height: "30px" }}>
                                <td style={{ border: "1px solid #000", borderTop: "none", borderBottom: "none" }}></td>

                                <td style={{ textAlign: "left", paddingLeft: "10px", border: "1px solid #000" }}>
                                    {item.NoiDung}
                                </td>
                                <td style={{ textAlign: "center", border: "1px solid #000", color: "#009da0" }}>
                                    {!isRutQuy ? (       
                                        <span>{formatNumber(item.Thu)}</span>
                                    ) : (
                                        <span></span>
                                    )}
                                </td>
                                <td style={{ textAlign: "center", border: "1px solid #000", color: "red" }}>
                                    {formatNumber(item.Chi)}
                                </td>
                            </tr>
                        );
                    })}
                    <tr style={{ height: "35px", backgroundColor: "#fff" }}>
                        <td style={{ textAlign: "center", fontWeight: "bold", border: "1px solid #000", borderTop: "1px solid #000" }}>
                            {displayDateTo}
                        </td>
                        <td style={{ textAlign: "left", paddingLeft: "10px", fontWeight: "bold", border: "1px solid #000" }}>
                            Tiền cuối kỳ
                        </td>
                        <td colSpan="2" style={{ textAlign: "center", fontWeight: "bold", color: "red", fontSize: "15px", border: "1px solid #000" }}>
                            {formatNumber(cuoiKy)}
                        </td>
                    </tr>
                </tbody>
            </table>
            <style>
                {`
                    @media print {
                        @page { size: A4 portrait; margin: 10mm; }                        
                        #tblPrintQuyTienMatDongTien { width: 100%; }
                        #tblPrintQuyTienMatDongTien .table-bordered th, 
                        #tblPrintQuyTienMatDongTien .table-bordered td { 
                            border: 1px solid #000 !important; 
                        }
                        #tblPrintQuyTienMatDongTien .table-bordered td:first-child { 
                            border-top: none; 
                            border-bottom: none; 
                        }
                        #tblPrintQuyTienMatDongTien .table-bordered tr:first-child td:first-child { 
                            border-top: 1px solid #000; 
                        }
                        #tblPrintQuyTienMatDongTien .table-bordered tr:last-child td:first-child { 
                            border-bottom: 1px solid #000; 
                            border-top: 1px solid #000; 
                        }
                    }
                `}
            </style>
        </div>
    );
});

export default InDsQuyTienMat;